import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { StoreModel } from 'src/app/models/archive/store.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { ConceptInvoicingService } from 'src/app/services/invoicing/concept-invoicing.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { OpenStockFrom } from './../../../../enum/open-stock-from-enums';
import { CostCenterPriceModel } from './../../../../models/archive/cost-center-price.model';
import { RemissionDetailModel } from './../../../../models/rental/remission-detail';
import { RemissionModel } from './../../../../models/rental/remission.model';
import { RentalStockModel } from './../../../../models/rental/rental-stock-response.model';
import { CostCenterPriceService } from './../../../../services/archive/cost-center-price.service';
import { RemissionDetailService } from './../../../../services/rental/remission-detail.service';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-remission-detail',
  templateUrl: './register-remission-detail.component.html',
  styleUrls: ['./register-remission-detail.component.scss'],
  standalone: false
})
export class RegisterRemissionDetailComponent implements OnChanges {
  @Input() remissionContract: RemissionModel = new RemissionModel();
  @Input() remissionDetailContract: RemissionDetailModel = new RemissionDetailModel();
  @Input() swReservation: boolean = false;
  @Output() isFormView = new EventEmitter<boolean>();
  @Output() updateListDetail = new EventEmitter<boolean>();
  //Variables para el control del modal de Precios C.Costos:
  @Output() costCenterPriceRegister = new EventEmitter<CostCenterPriceModel>();
  @Input() costCenterPriceContract: CostCenterPriceModel = new CostCenterPriceModel();

  articleId: number = 0;
  codeNameArticle: string = '';
  codeNameStore: string = '';
  columnSortArticle: string | null = null;
  componentTableSelection = CustomTableSelectComponent;
  conceptInvoicingIdAlquiler: number = 0;
  dataArticle: PagedResponseModel<RentalStockModel> = new PagedResponseModel<RentalStockModel>();
  disableButtonSave: boolean = false;
  filtersArticle: ColumnResponseModel[] = [];
  formRemissionDetail: FormGroup = new FormGroup({});
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
  });
  limitArticle: number = 10;
  listStore: any[] = [];
  openStockFromRemission = OpenStockFrom.remision;
  output$ = new Subject<any>();
  pageArticle: number = 1;
  remissionDetailId: number = 0;
  stock: number = 0;
  storeId: number = 0;
  subscription: Subscription;

  constructor(private articleService: ArticleService,
    private storeService: StoreService,
    private conceptInvoicingService: ConceptInvoicingService,
    private costCenterPriceService: CostCenterPriceService,
    private formBuilder: UntypedFormBuilder,
    private formControlStateService: FormControlStateService,
    private remissionDetailService: RemissionDetailService,
    private toastHandlerService: ToastHandlerService,) {
    this.validateForm(this.remissionDetailContract);
    this.getConceptInvoicingRental();
  }

  async ngOnChanges(changes: SimpleChanges) {
    const remissionDetailContract = changes['remissionDetailContract'];
    const costCenterPriceContract = changes["costCenterPriceContract"];
    if (remissionDetailContract) {
      if (this.remissionDetailContract.remissionDetailId == 0) {
        this.createNewRemissionDetail();
      } else {
        this.remissionDetailId = this.remissionDetailContract.remissionDetailId;
        await this.validateForm(this.remissionDetailContract);
      }
    }
    if (costCenterPriceContract && !costCenterPriceContract.firstChange) {
      this.getCostCenterPriceRegister(costCenterPriceContract.currentValue);
    }
  }

  clearForm() {
    this.codeNameArticle = "";
    const modelRemissionDetail = new RemissionDetailModel;
    this.validateForm(modelRemissionDetail)
    this.isFormView.emit(false);
  }

  async createAndUpdateRemissionDetail(remissionDetail: RemissionDetailModel) {
    if (this.remissionDetailId == 0) {
      await firstValueFrom(this.remissionDetailService.createRemissionDetail(remissionDetail));
      this.toastHandlerService.showToast(
        'success',
        'El detalle de la remisión fue creada exitosamente.'
      );
    } else {
      await firstValueFrom(this.remissionDetailService.updateRemissionDetail(remissionDetail));
      this.toastHandlerService.showToast(
        'success',
        'El detalle de la remisión fue modificado exitosamente.'
      );
    }
    this.isFormView.emit(false);
    this.updateListDetail.emit(true);
    this.remissionDetailContract = new RemissionDetailModel();
    this.clearForm()
  }

  createCostCenterPrice() {
    const costCenterPriceRegister = new CostCenterPriceModel();
    costCenterPriceRegister.costCenterId = this.remissionContract.costCenterId;
    costCenterPriceRegister.articleId = this.remissionDetailContract.articleId;
    this.costCenterPriceRegister.emit(costCenterPriceRegister);
  }

  createNewRemissionDetail() {
    this.remissionDetailId = 0;
    this.costCenterPriceContract = new CostCenterPriceModel();
    this.validateForm(this.remissionDetailContract);
  }

  async changeQuantity(currentQuantity: number) {
    if (!this.swReservation) return;
    const form = this.formRemissionDetail.controls;
    const previousQuantity = this.remissionDetailContract.quantity;
    const stockBase = form["stock"].value + previousQuantity;
    const availableBase = form["availableStock"].value + previousQuantity;
    if (currentQuantity > availableBase) {
      const result = await Swal.fire({
        title: 'Atención',
        text: `La cantidad solicitada (${currentQuantity}) supera la cantidad disponible (${availableBase}).
          ¿Desea despachar la cantidad máxima disponible?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      });
      if (result.isConfirmed) {
        currentQuantity = availableBase;
      } else {
        form["quantity"].patchValue(previousQuantity);
        return;
      }
    }
    const nuevoDisponible = availableBase - currentQuantity;
    const nuevoStock = stockBase - currentQuantity;
    form["stock"].patchValue(nuevoStock);
    form["availableStock"].patchValue(nuevoDisponible);
    form["quantity"].patchValue(currentQuantity);
    this.remissionDetailContract.quantity = currentQuantity;
  }

  async getArticle(articleId: number | null, reload: boolean) {
    let validArticle = null;
    let codeNameArticle = "";
    if (articleId != null) {
      const article = await firstValueFrom(this.articleService.getArticleById(articleId));
      if (article) {
        validArticle = articleId;
        codeNameArticle = `${article.code} - ${article.name}`;
        if (!article.active) {
          this.toastHandlerService.showToast(
            'warning',
            'El artículo seleccionado se encuentra inactivo.',
          );
        }
      }
    }
    this.articleId = validArticle ?? 0;
    this.codeNameArticle = codeNameArticle;
    this.formRemissionDetail.controls["articleId"].patchValue(validArticle);
    if (reload) {
      await this.getRemissionDetailByKeys();
    }
  }

  async getConceptInvoicingRental() {
    try {
      const response = await firstValueFrom(this.conceptInvoicingService.getConceptInvoicingAlquiler());
      this.conceptInvoicingIdAlquiler = response.conceptInvoicingId;
    } catch (error) {
      console.error('Error al obtener el concepto de facturación de alquiler.', error);
    }
  }

  //Obtener el valor del art. en precios por cco.
  async getCostCenterPriceByKeys(costCenterId: number, articleId: number) {
    if (articleId != null && articleId != 0) {
      const response = await firstValueFrom(this.costCenterPriceService
        .getCostCenterPriceByKeys(costCenterId, this.conceptInvoicingIdAlquiler, articleId));
      if (response.costCenterPriceId != 0 && response.baseUnitValue != -1) { //Existe en precio por cco.
        this.disableButtonSave = false;
        this.formRemissionDetail.controls["unitInvoiced"].patchValue(response.swInvoiceUnitM2 ? 'm2' : 'Unidad');
        this.formRemissionDetail.controls["baseUnitValue"].patchValue(response.baseUnitValue);
        this.formRemissionDetail.controls["discount"].patchValue(response.rateDiscount);
        this.formRemissionDetail.controls["unitValue"].patchValue(response.unitValue);
        this.costCenterPriceContract = response;
      } else if (response.costCenterPriceId == 0 && response.baseUnitValue != -1) { // NO existe en precios cco. pero si el lista de precios
        this.disableButtonSave = false;
        this.formRemissionDetail.controls["unitInvoiced"].patchValue('');
        this.formRemissionDetail.controls["baseUnitValue"].patchValue(0);
        this.formRemissionDetail.controls["discount"].patchValue(0);
        this.formRemissionDetail.controls["unitValue"].patchValue(0);
        this.costCenterPriceContract = response;
      } else { //NO existe en precios cco. Ni en lista de precios
        this.disableButtonSave = true;
        this.formRemissionDetail.controls["unitInvoiced"].patchValue('');
        this.formRemissionDetail.controls["baseUnitValue"].patchValue(0);
        this.formRemissionDetail.controls["discount"].patchValue(0);
        this.formRemissionDetail.controls["unitValue"].patchValue(0);
        this.toastHandlerService.showToast(
          'error',
          'El artículo NO se encuentra registrado en la lista de Precios.'
        );
      }
    }
  }

  async getCostCenterPriceRegister(costCenterPriceContract: CostCenterPriceModel) {
    if (costCenterPriceContract.costCenterPriceId == 0) { return; }
    this.remissionDetailContract.costCenterPrice = costCenterPriceContract

    try {
      this.createAndUpdateRemissionDetail(this.remissionDetailContract);
    } catch (error) {
      console.error('Error al guardar el detalle.', error);
    }
  }

  async getRemissionDetailByKeys() {
    if (this.storeId === 0 || this.articleId === 0) return;
    const remissionId = this.remissionContract.remissionId;
    const response = await firstValueFrom(
      this.remissionDetailService.getRemissionDetailByKeys(remissionId, this.storeId, this.articleId)
    );
    if (response.remissionDetailId === 0) {
      this.remissionDetailId = 0;
      this.remissionDetailContract = new RemissionDetailModel();
      this.remissionDetailContract.storeId = this.storeId;
      this.remissionDetailContract.articleId = this.articleId;
      await this.validateForm(this.remissionDetailContract);
    } else {
      this.remissionDetailContract = response;
      this.remissionDetailId = response.remissionDetailId;
      await this.validateForm(this.remissionDetailContract);
    }
  }

  async getStocksByArticleId(storeId: number, articleId: number) {
    if (!storeId || !articleId) {
      this.formRemissionDetail.patchValue({ stock: null, availableStock: null });
      return;
    }
    try {
      const rentalStockModel = new RentalStockModel();
      rentalStockModel.articleId = articleId;
      rentalStockModel.storeId = storeId;
      rentalStockModel.dateMovement = this.remissionContract.dateRemission;
      const response = await firstValueFrom(this.remissionDetailService.getStocksByArticleIdStoreId(rentalStockModel));
      const { stock, availableStock } = response;
      this.formRemissionDetail.patchValue({ stock, availableStock });
    } catch (error) {
      console.error('Error al obtener el stock.', error);
    }
  }

  async getStore(storeId: number | null) {
    let validStore = null;
    let store = new StoreModel();
    if (storeId != null) {
      store = await firstValueFrom(this.storeService.getStoreById(storeId));
      if (store) {
        validStore = storeId;
      }
    }

    this.storeId = validStore ?? 0;
    this.formRemissionDetail.controls["storeId"].patchValue(validStore);
    this.formRemissionDetail.controls["storeCodeName"].patchValue(`${store.code} - ${store.name}`);
  }

  async send() {
    this.formRemissionDetail.controls['remissionId'].patchValue(
      this.remissionContract.remissionId
    );
    this.validateFormControls();
    if (!this.formRemissionDetail.valid) {
      this.showValidationMessages();
      return;
    }
    const modelRemissionDetail = this.setForm();
    //Valido si el artículo viene de un pedido
    if (this.remissionDetailContract.orderDetailId != null) {
      this.toastHandlerService.showToast('warning', 'No es posible modificar, este artículo viene desde un pedido.', 'Atención');
      return;
    }
    modelRemissionDetail.detailText = modelRemissionDetail.detailText || null;
    try {
      this.costCenterPriceContract = await firstValueFrom(this.costCenterPriceService.getCostCenterPriceByKeys(this.remissionContract.costCenterId,
        this.conceptInvoicingIdAlquiler, modelRemissionDetail.articleId));
      if (this.costCenterPriceContract.costCenterPriceId == 0) {
        this.remissionDetailContract.remissionDetailId = this.remissionDetailId;
        this.remissionDetailContract.costCenterPrice = this.costCenterPriceContract;
        this.createCostCenterPrice();
      } else {
        modelRemissionDetail.costCenterPrice = this.costCenterPriceContract;
        try {
          this.createAndUpdateRemissionDetail(this.remissionDetailContract);
        } catch (error) {
          console.error('Error al guardar el detalle.', error);
        }
      }
    } catch (error) {
      console.error('Error al guardar el detalle.', error);
    }
  }

  setForm(): any {
    this.remissionDetailContract.remissionId = this.formRemissionDetail.get("remissionId")?.value;
    this.remissionDetailContract.articleId = this.formRemissionDetail.get("articleId")?.value;
    this.remissionDetailContract.storeId = this.formRemissionDetail.get("storeId")?.value;
    this.remissionDetailContract.quantity = this.formRemissionDetail.get("quantity")?.value;
    this.remissionDetailContract.detailText = this.formRemissionDetail.get("detailText")?.value;
    return this.remissionDetailContract;
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      remissionId: {
        required: 'El campo remisión es obligatorio.',
        min: 'Debes seleccionar un remisión válido.',
      },
      articleId: {
        required: 'El campo artículo es obligatorio.',
        min: 'Debes seleccionar un artículo válido.',
      },
      storeId: {
        required: 'El campo Bodega es obligatorio.',
        min: 'Debes seleccionar una Bodega válida.',
      },
      quantity: {
        required: 'El campo Cantidad es obligatorio.',
        min: 'La Cantidad mínima permitida es 1.',
        max: 'La Cantidad no puede superar 9.999.999,99.',
      },
      detailText: {
        max: 'El campo detalle permite un máximo de 60 carácteres',
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formRemissionDetail.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async validateForm(remissionDetail: RemissionDetailModel) {
    this.formRemissionDetail = this.formBuilder.group({
      stock: [0],
      availableStock: [0],
      discount: [0],
      unitValue: [0],
      baseUnitValue: [0],
      unitInvoiced: [],
      storeCodeName: [],
      remissionId: [remissionDetail.remissionId, [Validators.required, Validators.min(1)]],
      articleId: [remissionDetail.articleId, [Validators.required, Validators.min(1)]],
      storeId: [remissionDetail.storeId, [Validators.required, Validators.min(1)]],
      quantity: [remissionDetail.quantity, [Validators.required, Validators.min(1), Validators.max(9999999.99)]],
      detailText: [remissionDetail.detailText, [Validators.maxLength(60)]],
    });
    const controlsToDisable = ['storeCodeName', 'stock', 'unitInvoiced', 'baseUnitValue',
      'discount', 'unitValue', 'availableStock'];
    setTimeout(() => this.formControlStateService.setControlState(this.formRemissionDetail, controlsToDisable, false));
    if (remissionDetail.articleId > 0) {
      this.isFormView.emit(true);
      await Promise.all([
        this.getStore(remissionDetail.storeId),
        this.getArticle(remissionDetail.articleId, false),
        this.getStocksByArticleId(remissionDetail.storeId, remissionDetail.articleId),
        this.getCostCenterPriceByKeys(this.remissionContract.costCenterId, this.remissionDetailContract.articleId)
      ]);
    }
  }

  validateFormControls() {
    Object.keys(this.formRemissionDetail.controls).forEach((key) => {
      const control = this.formRemissionDetail.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
